import type { Photo } from './config';

export const MAX_PHOTOS = 6;
const MAX_EDGE = 1600;

function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error(`Could not read ${file.name}`));
    };
    img.src = url;
  });
}

/** Downscales to JPEG so uploads stay small on mobile connections. */
export async function resizePhoto(file: File): Promise<Photo> {
  const img = await loadImage(file);
  const scale = Math.min(1, MAX_EDGE / Math.max(img.naturalWidth, img.naturalHeight));
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(img.naturalWidth * scale);
  canvas.height = Math.round(img.naturalHeight * scale);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas is not supported');
  ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
    name,
    dataUrl: canvas.toDataURL('image/jpeg', 0.8),
  };
}
